/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 16,
    height: 15,
    viewBox: '0 0 16 14',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#008579"><path pid="0" d="M8 0v11"/><path pid="1" stroke-linecap="square" d="M4 7l4 4 4-4M1 11.5V14h14v-2.5"/></g>'
  }
})
